import { ROLES_GESTAO_ORCAMENTARIA } from "./departamentosOrcamento";

// Visão Executiva Custos / Visão Executiva Despesas: expõe salário individual/agregado e
// concentração de gastos por categoria mãe. Um único endpoint atende as duas telas:
// admin/EXECUTIVA veem todos os departamentos de uma vez; as 7 roles de departamento só
// recebem o(s) seu(s) próprio(s) (filtro aplicado no backend — ver routers/visao_executiva_geral.py).
// Espelha backend/config.py ROLES_VISAO_EXECUTIVA_GERAL — mantenha em sincronia.
export const ROLES_VISAO_EXECUTIVA_GERAL = ["admin", "EXECUTIVA", ...ROLES_GESTAO_ORCAMENTARIA.filter((r) => r !== "admin")];

// Divisão de tela só de roteamento/sidebar (a API é a mesma para as duas, ver
// ROLES_VISAO_EXECUTIVA_GERAL acima) — "Visão Executiva Custos" é a visão exclusiva da
// Operação; "Visão Executiva Despesas" cobre os demais departamentos.
export const ROLES_VISAO_EXECUTIVA_CUSTOS = ["admin", "EXECUTIVA", "GESTOR_ESTRATEGICO", "OPERACAO"];
export const ROLES_VISAO_EXECUTIVA_DESPESAS = [
  "admin", "EXECUTIVA", "GESTOR_ESTRATEGICO", "COMERCIAL", "MARKETING", "QUALIDADE", "RH", "TI",
];
